import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Spinner,
  Label,
} from "reactstrap";
import { login } from "store/actions/authAction";
import schoolImage from "../../assets/img/custom/registerSchool.png";
import collectiveImage from "../../assets/img/custom/registerCollective.png";

const Login = () => {
  let dispatch = useDispatch();
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [loader, setLoader] = useState(false);

  // Get redirect param from URL
  const urlParams = new URLSearchParams(window.location.search);
  const redirectParam = urlParams.get("redirect"); // 'school' ya 'collective' ya null

  const handleChange = (e) => {
    let { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    dispatch(
      login(loginData, () => {
        setLoader(false);
      })
    );
  };

  return (
    <>
      <Col lg="7" md="9">
        <Row className="my-3">
          <Col md="12">
            <Card className="p-2 d-flex justify-content-center align-items-center">
              <div className="d-flex justify-content-center">
                <img
                  src={schoolImage}
                  alt="Image 1"
                  className="img-fluid mx-2"
                  style={{ width: "50%", height: "50%" }}
                />
                <img
                  src={collectiveImage}
                  alt="Image 2"
                  className="img-fluid mx-2"
                  style={{ width: "50%", height: "50%" }}
                />
              </div>
            </Card>
          </Col>
        </Row>

        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign in</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                    name="email"
                    value={loginData.email}
                    onChange={handleChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    type="password"
                    autoComplete="new-password"
                    name="password"
                    value={loginData.password}
                    onChange={handleChange}
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  {loader ? <Spinner size="sm" /> : "Sign in"}
                </Button>
              </div>
            </Form>

            <div className="mt-3 mx-0 mx-md-3 text-center">
              <Label className="auth-label">
                Don't have an account yet? Sign Up
              </Label>
            </div>

            {/* Conditional Buttons */}
            <div
              className={`d-flex ${
                redirectParam !== "collective" && redirectParam !== "school"
                  ? "justify-content-between"
                  : "justify-content-center"
              }`}
            >
              {redirectParam !== "collective" && (
                <Link to="/auth/register-school" className="btn btn-primary">
                  School
                </Link>
              )}
              {redirectParam !== "school" && (
                <Link
                  to="/auth/register-collective"
                  className="btn btn-primary"
                >
                  Collective
                </Link>
              )}
            </div>
          </CardBody>
        </Card>

        <Row className="mt-3">
          <Col xs="6">
            <Link className="text-light" to="/auth/forgot-password">
              <small>Forgot password?</small>
            </Link>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Login;
